"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledDivider = exports.Root = exports.Inner = exports.Container = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _productList = require("@ori/product-list");
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        maxWidth: 985,
        flexDirection: 'column',
        gap: theme.spacing(4),
        margin: theme.spacing(0, 'auto'),
        flexWrap: 'wrap',
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(8),
            width: '100%'
        }
    };
});
const Container = exports.Container = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(8),
            width: '100%'
        }
    };
});
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, isFocusPage } = param;
    return {
        boxSizing: 'border-box',
        display: 'block',
        margin: theme.spacing(0, 'auto'),
        padding: theme.spacing(0, 3),
        width: '100%',
        ...isFocusPage && {
            [".".concat(_productList.productListClasses.root)]: {
                maxWidth: 300
            },
            [theme.breakpoints.up('sm')]: {
                [".".concat(_productList.productListClasses.root)]: {
                    maxWidth: 615
                }
            },
            [theme.breakpoints.up('md')]: {
                [".".concat(_productList.productListClasses.root)]: {
                    maxWidth: 1245
                }
            }
        }
    };
});
const StyledDivider = exports.StyledDivider = (0, _mui.styled)(_mui.Divider)((param)=>{
    let { theme } = param;
    return {
        width: '95%',
        height: 2,
        backgroundColor: theme.palette.grey[100],
        margin: theme.spacing(0, 'auto'),
        [theme.breakpoints.up('sm')]: {
            margin: 0,
            width: '100%'
        }
    };
});
